module.exports = __webpack_public_path__ + "img/success_bg.ddc8d3b3.png";